module.exports = __webpack_public_path__ + "stamp.1ce25a1.png";